import React from "react";

export const ChatBubble = ({ children, side = "in", time = "अभी", testId }) => {
  const isIn = side === "in";
  return (
    <div
      className={`flex ${isIn ? "justify-start" : "justify-end"} w-full`}
      data-testid={testId}
    >
      <div
        className={`relative max-w-[85%] px-4 py-3 text-[15px] leading-relaxed shadow-sm ${
          isIn
            ? "bg-white border border-[#EFEAE2] text-[#191919] rounded-2xl rounded-tl-sm"
            : "bg-whatsapp-bg border border-whatsapp-bgBorder text-[#0B3D1B] rounded-2xl rounded-tr-sm"
        }`}
      >
        <div>{children}</div>
        <div className="mt-1 text-[11px] text-muted-foreground text-right">
          {time} {isIn ? "" : "✓✓"}
        </div>
      </div>
    </div>
  );
};

export const TypingDots = () => (
  <div className="flex items-center gap-1 px-4 py-3 bg-white border border-[#EFEAE2] rounded-2xl rounded-tl-sm w-fit">
    <span className="h-2 w-2 rounded-full bg-[#A0A0A0] animate-typing" />
    <span
      className="h-2 w-2 rounded-full bg-[#A0A0A0] animate-typing"
      style={{ animationDelay: "150ms" }}
    />
    <span
      className="h-2 w-2 rounded-full bg-[#A0A0A0] animate-typing"
      style={{ animationDelay: "300ms" }}
    />
  </div>
);

export default ChatBubble;
